export default __webpack_public_path__ + "static/media/illustration-risk_share.7c308d94.png";